import React, { Component } from "react";
import { getCurrentUser, logout, encryptData, decryptData, prestadoresCategorias, formataCPF, tiposAcesso } from '../../common/utils';
import { FiMenu, FiSearch, FiLoader, FiX } from 'react-icons/fi';
import api from "../../services/api";
import { perguntasDaCategoria } from '../../common/config';
import { Navbar, Button, Nav, NavDropdown, Container, Form, InputGroup, ListGroup, Spinner } from "react-bootstrap";
import Cookies from 'js-cookie';
import TermosAcceptModal from '../../components/Modals/TermosAcceptModal'; 
import NotificacaoBell from './NotificacaoBell';
import Swal from 'sweetalert2'
import Select from 'react-select';
import ModalTrocaPrograma from '../Modals/ModalTrocaPrograma';
import programSwitchService from '../../services/programSwitchService';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { SeletorIdiomaNav } from '../../common/_components/SeletorIdioma';

const TERMOS_CACHE_KEY = 'termos_ultima_verificacao';
const TERMOS_CACHE_DURATION = 12 * 60 * 60 * 1000; // 12 horas em milissegundos

class TopNavigation extends Component {
    constructor(props) {
        super(props);

        this.carregarBusca = this.carregarBusca.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.clearSearch = this.clearSearch.bind(this);

        this.state = {
            currentUser: {},
            termoBusca: '',
            busca: "",
            exibe_busca: false,
            buscando: false,
            carregaprogramas: true,
            showSwitchModal: false,
            selectedProgram: null,
            resultados: {},
            dadosPrograma: {},
            loadingTermos: true,
            showTermosModal: false,
            termosPendentes: [],
            // Termos dinâmicos do profissional (Termos_Dinamicos do programa) exibidos no modal de aceite
            termosDinamicos: [],
            termosDinamicosTitulo: '',
            termosDinamicosPrestadorUuid: null,
            termosDinamicosProgramaUuid: null,
            termosDinamicosRespostas: {},
            // Nomenclatura do "escolher programa" no seletor do topo (ex.: Chiesi = "Patologia")
            nomenclaturaPrograma: '',
            // Frase do checkbox de aceite do termo no modal (configurável por programa)
            labelAceiteTermos: '',
        };

        this.searchContainer = React.createRef();
    }

    // Lê a nomenclatura do "escolher programa" do programa atual do médico (ex.: Chiesi = "Patologia")
    // para usar no seletor do topo. Best-effort: sem config, mantém o texto padrão.
    carregarNomenclaturaPrograma = async () => {
        try {
            const usuario = getCurrentUser();
            const programaId = usuario?.ambiente_programa_id;
            if (usuario?.prestador_categoria !== 'medicos' || !programaId) return;
            const { data: programa } = await api.get(`/programas/${programaId}/`);
            const nom = programa?.configuracoes?.nomenclatura_escolha_programa;
            if (nom) this.setState({ nomenclaturaPrograma: nom });
            const labelAceite = programa?.configuracoes?.termos_medico?.label_aceite_termos;
            if (labelAceite) this.setState({ labelAceiteTermos: labelAceite });
        } catch (e) { /* mantém padrão */ }
    };

    // Carrega os termos dinâmicos (Termos_Dinamicos) do programa para o médico logado, para serem
    // exibidos no modal de aceite e salvos no cadastro do médico. Best-effort: em qualquer falha,
    // retorna vazio (o modal segue só com o termo de plataforma).
    carregarTermosDinamicosPrestador = async (usuario, programaId) => {
        const vazio = {
            termosDinamicos: [],
            termosDinamicosTitulo: '',
            termosDinamicosPrestadorUuid: null,
            termosDinamicosProgramaUuid: null,
            termosDinamicosRespostas: {},
        };
        try {
            //Vale para qualquer prestador: quem responde o que e decidido pela chave
            //`categorias` de cada pergunta, nao pela categoria fixa no codigo. Pergunta sem
            //`categorias` continua valendo so para medico, entao programa nenhum muda.
            const prestadorId = usuario?.prestador_id;
            if (usuario?.tipo_usuario !== 'prestador' || !prestadorId || !programaId) return vazio;

            const { data: programa } = await api.get(`/programas/${programaId}/`);
            const cfg = programa?.configuracoes?.Termos_Dinamicos || {};
            if (cfg.habilitado_termo_dinamico_medico !== true) return vazio;
            const questions = perguntasDaCategoria(cfg.Questions, usuario?.prestador_categoria);
            if (questions.length === 0) return vazio;

            const { data: prestador } = await api.get(`/pessoas/prestadores/${prestadorId}/`);
            const prestadorUuid = prestador?.uuid || null;
            if (!prestadorUuid) return vazio;

            // Respostas já gravadas (pré-preenche), best-effort.
            let respostas = {};
            try {
                const { data: vinc } = await api.get(`/programas/prestadores/?prestador_id=${prestadorId}&programa_id=${programaId}`);
                const lista = Array.isArray(vinc) ? vinc : (vinc?.results || []);
                respostas = lista?.[0]?.termos_dinamicos_respostas_json || {};
            } catch (e) { /* ignora: segue sem pré-preencher */ }

            return {
                termosDinamicos: questions,
                //o titulo vem da configuracao: com nutricionista no fluxo, "Consentimentos
                //do Medico" fixo mentia sobre quem esta assinando
                termosDinamicosTitulo: cfg.titulo || '',
                termosDinamicosPrestadorUuid: prestadorUuid,
                termosDinamicosProgramaUuid: programa?.uuid || null,
                termosDinamicosRespostas: respostas || {},
            };
        } catch (e) {
            console.error('Erro ao carregar termos dinâmicos do médico:', e);
            return vazio;
        }
    };

    checkTermosPendentes = async () => {
        // Enquanto o ambiente (programa) não foi confirmado — ex.: médico/prestador que ainda vai
        // escolher o programa na home — não dispara o termo, senão pega o termo do programa errado.
        // Só verifica após acesso_liberado (programa definido). Aí o termo vem para o programa certo.
        const dadosOutrosInicial = decryptData('o');
        if (dadosOutrosInicial && dadosOutrosInicial['acesso_liberado'] === false) {
            this.setState({ loadingTermos: false });
            return;
        }

        // Verifica se já checou recentemente (cache)
        const ultimaVerificacao = localStorage.getItem(TERMOS_CACHE_KEY);
        const agora = Date.now();        

        if (ultimaVerificacao) {
            const tempoDecorrido = agora - parseInt(ultimaVerificacao, 10);

            if (tempoDecorrido < TERMOS_CACHE_DURATION) {
                // Ainda está no período de cache, não precisa verificar na API
                this.setState({ loadingTermos: false });
                return;
            }
        }

        try {
            const usuario = getCurrentUser();
            const programaId = usuario?.ambiente_programa_id;

            // Sem programa autenticado, não há como saber quais termos verificar.
            if (!programaId) {
                this.setState({ loadingTermos: false });
                return;
            }

            // Prestadores de categorias não-médicas não são alvo dos termos de plataforma.
            const categoriasComTermo = ['medicos', 'multiprofissionais'];
            if (usuario?.tipo_usuario === 'prestador' && !categoriasComTermo.includes(usuario?.prestador_categoria)) {
                this.setState({ loadingTermos: false });
                return;
            }

            const params = {
                programa: programaId,
                categoria: usuario?.prestador_categoria
            };

            const response = await api.get('/termos-plataforma/termos-pendentes/', { params });

            // O backend só recorta por programa quando o programa é do tipo "cliente"
            // (tipo_cadastro_medico). Em programas do tipo "programa" — caso do Conecta
            // PKU — o recorte não acontece e vinham termos de outros clientes (um
            // profissional do PKU recebia o termo da Chiesi). Aqui garantimos que um
            // termo com "programas" definido só apareça dentro de um deles; termo sem
            // escopo continua valendo para todos.
            const termosDoPrograma = (response.data || []).filter(termo => {
                const escopo = Array.isArray(termo?.programas) ? termo.programas.map(Number) : [];
                return escopo.length === 0 || escopo.includes(Number(programaId));
            });

            if (termosDoPrograma.length > 0) {
                // Tem termos pendentes - NÃO salva no cache. Exibe o modal imediatamente.
                this.setState({
                    termosPendentes: termosDoPrograma,
                    showTermosModal: true,
                    loadingTermos: false,
                });
                // Para médicos, carrega os termos dinâmicos do programa em paralelo, SEM bloquear a
                // exibição do modal (se a busca falhar/atrasar, o termo de plataforma já aparece).
                this.carregarTermosDinamicosPrestador(usuario, programaId)
                    .then(dados => this.setState(dados))
                    .catch(() => {});
            } else {
                // Não tem termos pendentes - salva no cache
                localStorage.setItem(TERMOS_CACHE_KEY, agora.toString());
                this.setState({ loadingTermos: false, termosPendentes: [] });
            }
        } catch (error) {
            console.error("Erro ao verificar termos pendentes:", error);
            
            // Se for erro 403 (Forbidden), a sessão/permissão expirou
            if (error.response && error.response.status === 403) {
               logout();
               const programa_login = Cookies.get('p_login');
               Cookies.remove('p_login', { path: '/' });
   
               if (programa_login) {
                   window.location.href = `/login/?p=${programa_login}`;
               } else {
                   window.location.href = '/login';
               }
               return;
            }

            this.handleTermosRecusados(); 
        }
    };

    componentDidMount() {
        this.checkTermosPendentes();
        this.carregarNomenclaturaPrograma();

        const currentUser = getCurrentUser();
        this.setState({ currentUser: currentUser });
        document.addEventListener('mousedown', this.handleClickOutside);

        if(currentUser['tipo_usuario'] === 'operador') {
            this.getProgramasOperador(currentUser["ambiente_carteira_id"], currentUser["ambiente_programa_id"]);
        } else if(currentUser['tipo_usuario'] === 'gestor' && this.isPerfilGestorIndustria()) {
            this.getProgramasGestorIndustria(currentUser["gestor_id"], currentUser["ambiente_programa_id"]);
        } else if(currentUser['tipo_usuario'] === 'gestor') {
            this.getProgramasGestor(currentUser["ambiente_cliente_id"], currentUser["ambiente_programa_id"]);
        } else if(currentUser['tipo_usuario'] === 'prestador') {
            this.getProgramasPrestador(currentUser["ambiente_cliente_id"], currentUser["ambiente_programa_id"]);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const dados_usuario = getCurrentUser();
        if (
            dados_usuario['tipo_usuario'] === 'operador' &&
            (dados_usuario["ambiente_carteira_id"] !== prevState.ambiente_carteira_id || 
             dados_usuario["ambiente_programa_id"] !== prevState.ambiente_programa_id)
        ) {
            this.getProgramasOperador(dados_usuario["ambiente_carteira_id"], dados_usuario["ambiente_programa_id"]);
        } else if (
            dados_usuario['tipo_usuario'] === 'gestor' &&
            dados_usuario["ambiente_programa_id"] !== prevState.ambiente_programa_id &&
            this.isPerfilGestorIndustria()
        ) {
            this.getProgramasGestorIndustria(dados_usuario["gestor_id"], dados_usuario["ambiente_programa_id"]);
        } else if (
            dados_usuario['tipo_usuario'] === 'gestor' &&
            dados_usuario["ambiente_programa_id"] !== prevState.ambiente_programa_id
        ) {
            this.getProgramasGestor(dados_usuario["ambiente_cliente_id"], dados_usuario["ambiente_programa_id"]);
        } else if (
            dados_usuario['tipo_usuario'] === 'prestador' &&
            dados_usuario["ambiente_programa_id"] !== prevState.ambiente_programa_id
        ) {
            this.getProgramasPrestador(dados_usuario["ambiente_cliente_id"], dados_usuario["ambiente_programa_id"]);
        }
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside(event) {
        // Verifica se o clique foi fora da área do campo de busca
        /*if (this.searchContainer && !this.searchContainer.current.contains(event.target)) {
            this.setState({ exibe_busca: false });
        }*/
    }

    clearSearch() {
        // Limpa o campo de busca e esconde a caixa de resultados
        this.setState({ termoBusca: '', resultados: {}, exibe_busca: false });
    }

    logOut = async (event) => {
        // Limpa cache de termos ao fazer logout
        localStorage.removeItem(TERMOS_CACHE_KEY);
        
        logout();

        // Obtém `p_login` dos cookies
        const programa_login = Cookies.get('p_login');

        // Remove o cookie `p_login`
        Cookies.remove('p_login', { path: '/' });

        // Redireciona o usuário conforme a presença dos parâmetros
        if (programa_login) {
            window.location.href = `/login/?p=${programa_login}`;
        } else {
            window.location.href = '/login';
        }
    }



// ...

    alterarAmbiente = async (dados) => {
        const { t } = this.props;
        let dados_usuario = getCurrentUser();

        // Para médicos com programa de tipo_cadastro_medico 'cliente', troca sem modal de login
        if (dados_usuario['prestador_categoria'] === 'medicos' && dados.tipo_cadastro_medico === 'cliente') {
            Swal.fire({
                title: 'Troca de Programa',
                text: `Tem certeza que deseja acessar o programa ${dados.nome}?`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#bccd02',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Confirmar',
                cancelButtonText: 'Cancelar'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        await programSwitchService.performProgramSwitchSSO(
                            { uuid: dados.uuid, nome: dados.nome, id: dados.id },
                            null
                        );
                        window.location.href = '/';
                    } catch (error) {
                        console.error('Erro ao trocar de programa:', error);
                        Swal.fire({
                            icon: 'error',
                            title: 'Erro ao trocar de programa',
                            text: 'Não foi possível realizar a troca de programa. Tente novamente.',
                        });
                    }
                }
            });
            return;
        }

        // Comportamento original para médicos com outros tipos de cadastro médico
        if (dados_usuario['prestador_categoria'] === 'medicos') {
            if (dados.cliente_id && dados_usuario['ambiente_cliente_id'] && parseInt(dados.cliente_id) === parseInt(dados_usuario['ambiente_cliente_id'])) {
                Swal.fire({
                    title: t('layout:programSwitch.title'),
                    text: t('layout:programSwitch.confirm', { programa: dados.nome }),
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonColor: '#bccd02',
                    cancelButtonColor: '#d33',
                    confirmButtonText: t('common:button.confirm'),
                    cancelButtonText: t('common:button.cancel')
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        try {
                            await programSwitchService.performProgramSwitchSSO(
                                { uuid: dados.uuid, nome: dados.nome, id: dados.id },
                                null
                            );
                            window.location.href = '/';
                        } catch (error) {
                            const errMsg = error?.response?.data?.response || t('layout:programSwitch.unavailableFallback');
                            Swal.fire({
                                icon: 'warning',
                                title: t('layout:programSwitch.unavailableTitle'),
                                text: `${errMsg} ${t('layout:programSwitch.loginManually')}`,
                            }).then(() => {
                                this.setState({
                                    showSwitchModal: true,
                                    selectedProgram: dados
                                });
                            });
                        }
                    }
                });
                return;
            }

            this.setState({
                showSwitchModal: true,
                selectedProgram: dados
            });
            return;
        }

        if(dados.id){

            // Invalida cache do programa atual antes de trocar
            const programaAtualId = dados_usuario['ambiente_programa_id'];
            if (programaAtualId) {
                [
                    'logomarca', 'tipo_slug', 'nome', 'logomarca_timestamp',
                    'ocultar_receptivos', 'ocultar_atendimentos', 'ocultar_prestadores',
                    'menus_adicionais', 'gestao_aplicacoes', 'habilitar_tela_cod_veeva', 'habilitar_vouchers',
                    'configuracoes', 'configuracoes_timestamp'
                ].forEach(key => localStorage.removeItem(`programa_${key}_${programaAtualId}`));
            }

            api.get(`/programas/${dados.id}/`)
            .then(response => {
                /*const ocultar_receptivos = response.data.ocultar_menu_receptivos === true ? 'sim' : 'nao';
                const ocultar_atendimentos = response.data.ocultar_menu_atendimentos === true ? 'sim' : 'nao';
                const currentTime = new Date().getTime();

                localStorage.setItem(`programa_logomarca_${dados.id}`, response.data.imagem);
                localStorage.setItem(`programa_nome_${dados.id}`, response.data.nome);
                localStorage.setItem(`programa_logomarca_timestamp_${dados.id}`, currentTime);

                localStorage.setItem(`programa_ocultar_receptivos_${dados.id}`, ocultar_receptivos);
                localStorage.setItem(`programa_ocultar_atendimentos_${dados.id}`, ocultar_atendimentos);*/

                dados_usuario['ambiente_programa_cor_fundo'] = dados_usuario['ambiente_programa_cor_fundo'];
                dados_usuario['ambiente_programa_cor_primaria'] = dados_usuario['ambiente_programa_cor_primaria'];
                dados_usuario['ambiente_programa_cor_secundaria'] = dados_usuario['ambiente_programa_cor_secundaria'];
            
                // Armazena os dados no cookie
                Cookies.set("user", JSON.stringify(dados_usuario), { secure: true, sameSite: 'Strict', path: '/' });
                //UUID do programa
                let dados_prog = decryptData('prog');
                let dados_outros = decryptData('o');
                if (dados_outros) {
                    //console.log(dados_outros);
                    dados_outros['tipo_usuario'] = dados_outros['tipo_usuario'];
                    dados_outros['operador_id'] = dados_outros['operador_id'];
                    dados_outros['ambiente_cliente_id'] = dados_outros['ambiente_cliente_id'];
                    dados_outros['ambiente_programa_id'] = dados.id;
                    dados_outros['ambiente_carteira_id'] = dados_outros['ambiente_carteira_id'];
                    dados_outros['acesso_liberado'] = true;
                    encryptData('o', dados_outros);
                }
                dados_prog['ambiente_programa_uuid'] = response.data.uuid;
                encryptData('prog', dados_prog);
                
                if (dados_usuario['tipo_usuario'] === 'prestador' && dados_usuario['prestador_categoria'] === 'medicos') {
                    window.location.href = `/login/?p=${response.data.uuid}`;
                } else {
                    window.location.href = '/';
                }
            })
            .catch(error => {
                console.error('Erro ao carregar programa:', error);
            });

        } else {
            
            dados_usuario['ambiente_cliente_id'] = '';
            dados_usuario['ambiente_programa_id'] = '';
            dados_usuario['ambiente_carteira_id'] = '';
            Cookies.set("user", JSON.stringify(dados_usuario), { secure: true, sameSite: 'Strict', path: '/' });

            let dados_outros = decryptData('o');
            if (dados_outros) {
                dados_outros['acesso_liberado'] = false;
                encryptData('o', dados_outros);
                window.location.href = '/home';
            }
        }
        
    }

    handleSwitchSuccess = () => {
        this.setState({ showSwitchModal: false });
        window.location.href = '/';
    }



    sidebarToggle(e) {
        e.preventDefault();
        document.body.classList.toggle('sb-sidenav-toggled');
        localStorage.setItem('sb|sidebar-toggle', document.body.classList.contains('sb-sidenav-toggled'));
    }

    carregarBusca = async (termoBusca) => {
        this.setState({ buscando: true, exibe_busca: true });

        try {
            const response = await api.get(`/pesquisas/global/?busca=${termoBusca}`);
            const resultados = response.data.results[0]; // Acessa a primeira entrada do array de resultados
            this.setState({ 
                resultados: resultados, 
                buscando: false,
                exibe_busca: true,
            });
        } catch (error) {
            console.error("Erro ao buscar resultados:", error);
            this.setState({ buscando: false, exibe_busca: false });
        }
    };

    handleInputChange = (e) => {
        const termoBusca = e.target.value;
        this.setState({ termoBusca });

        clearTimeout(this.searchTimeout);
        if (termoBusca.trim().length >= 2) {
            this.searchTimeout = setTimeout(() => {
                this.carregarBusca(termoBusca);
            }, 500);
        } else {
            this.setState({ resultados: {}, exibe_busca: false }); // Oculta resultados se o campo estiver vazio
        }
    };

    getProgramasOperador = async (carteiraId, programaId) => {
        //console.log(this.state.carregaprogramas);
        if(this.state.carregaprogramas){
            if(carteiraId){
                this.setState({
                    carregaprogramas: false
                })
                try {
                    const response = await api.get(`/carteiras/programas/?carteira=${carteiraId}`);
                    const opcoes = response.data.results.filter(carteira => carteira.programa_id !== Number(programaId)).map(carteira => ({
                        id: carteira.programa_id,
                        nome: `${carteira.dados_programa.nome}`,
                        cliente_id: carteira.dados_cliente.id,
                    }));
    
                    this.setState({
                        carregaprogramas: false,
                        dadosPrograma: opcoes
                    })
                } catch (error) {
                    this.setState({
                        carregaprogramas: false
                    })
                    console.error('Erro ao carregar programas:', error);
                    return [];
                }
            }
            
        }
        //console.log(this.state.carregaprogramas);
    }

    isPerfilGestorIndustria = () => {
        const tipos_acesso = tiposAcesso();

        if ('gestor' in tipos_acesso) {
            if ('tipo_gestor' in tipos_acesso.gestor && tipos_acesso.gestor.tipo_gestor === 'industria') {
                return true;            
            }            
        }
        
        return false;
    }

    isPerfilGestorLeads = () => {
        const tipos_acesso = tiposAcesso();

        if ('gestor' in tipos_acesso) {
            if ('tipo_gestor' in tipos_acesso.gestor && tipos_acesso.gestor.tipo_gestor === 'leads') {
                return true;            
            }            
        }
        
        return false;
    }

    getProgramasGestor = async (clienteId, programaId) => {
        //console.log(this.state.carregaprogramas);
        if(this.state.carregaprogramas){
            if(clienteId){
                this.setState({
                    carregaprogramas: false
                })
                try {
                    const response = await api.get(`/programas/?cliente_id=${clienteId}&tipo_usuario=gestor`);
                    const opcoes = response.data.results.filter(programa => programa.id !== Number(programaId)).map(programa => ({
                        id: programa.id,
                        nome: `${programa.nome}`,
                        cliente_id: programa.cliente_id,
                    }));
    
                    this.setState({
                        carregaprogramas: false,
                        dadosPrograma: opcoes
                    })
                } catch (error) {
                    this.setState({
                        carregaprogramas: false
                    })
                    console.error('Erro ao carregar programas:', error);
                    return [];
                }
            }
            
        }
        //console.log(this.state.carregaprogramas);
    }

    /**
     * O gestor de indústria acompanha programas específicos, não o cliente inteiro. Por isso
     * a lista vem de /pessoas/gestores/programas/ (os vínculos dele), e não de /programas/
     * por cliente, que devolveria também os programas do mesmo cliente que ele não acompanha
     * — no CONECTA PKU, os dois SACs.
     *
     * É a mesma origem que o modal de escolha de ambiente já usa no login, então o seletor do
     * topo passa a oferecer exatamente os programas que ele vê ao entrar.
     */
    getProgramasGestorIndustria = async (gestorId, programaId) => {
        if (!this.state.carregaprogramas || !gestorId) {
            return;
        }

        this.setState({ carregaprogramas: false });

        try {
            const response = await api.get(`/pessoas/gestores/programas/?gestor_id=${gestorId}`);
            //o vínculo não carrega cliente: para este perfil o cliente não muda, só o programa
            const clienteAtual = getCurrentUser()['ambiente_cliente_id'];
            const opcoes = (response.data.results || [])
                .filter(vinculo => vinculo.programa_id !== Number(programaId))
                .map(vinculo => ({
                    id: vinculo.programa_id,
                    nome: vinculo.dados_programa?.nome,
                    cliente_id: clienteAtual,
                }));

            this.setState({ dadosPrograma: opcoes });
        } catch (error) {
            console.error('Erro ao carregar programas do gestor:', error);
        }
    }

    getProgramasPrestador = async (clienteId, programaId) => {
        if(this.state.carregaprogramas){
            const dados_usuario = getCurrentUser();
            let url = '';
            
            // Se for médico, usa o filtro de CRM/UF, mas considera o clienteId do ambiente atual
            if (dados_usuario['prestador_categoria'] === 'medicos') {
                url = `/programas/prestadores/?prestador_id=${dados_usuario.prestador_id}&crm_uf_filter=true&cliente_id=${clienteId}`;
            } else if (clienteId) {
                // Outros prestadores filtram por clienteId
                url = `/programas/prestadores/?prestador_id=${dados_usuario.prestador_id}&cliente_id=${clienteId}`;
            }

            if(url){
                this.setState({
                    carregaprogramas: false
                })
                try {
                    const response = await api.get(url);
                    const opcoes = response.data.results
                        .filter(programa => programa.programa_id !== Number(programaId))
                        .map(programa => ({
                            id: programa.programa_id,
                            nome: programa.dados_programa.nome,
                            cliente_id: programa.cliente_id,
                            uuid: programa.dados_programa.uuid,
                            tipo_cadastro_medico: programa.dados_programa.tipo_cadastro_medico,
                        }));
    
                    this.setState({
                        carregaprogramas: false,
                        dadosPrograma: opcoes
                    })
                } catch (error) {
                    this.setState({
                        carregaprogramas: false
                    })
                    console.error('Erro ao carregar programas do prestador:', error);
                    return [];
                }
            }
            
        }
    }

    renderResultados() {
        const { t } = this.props;
        const { resultados, buscando, termoBusca } = this.state;
        const temAtendimentos = resultados.atendimentos && resultados.atendimentos.length > 0;
        const temPacientes = resultados.pacientes && resultados.pacientes.length > 0;
        const temPrestadores = resultados.prestadores && resultados.prestadores.length > 0;

        if (buscando) {
            return <ListGroup.Item>{t('layout:search.searching')}</ListGroup.Item>;
        }

        if (!temAtendimentos && !temPacientes && !temPrestadores) {
            return <ListGroup.Item>{t('layout:search.noResults')}</ListGroup.Item>;
        }

        return (
            <>
                <ListGroup.Item><strong>Resultados da busca por {termoBusca}</strong></ListGroup.Item>
                {temAtendimentos && (
                    <>
                        <ListGroup.Item className="no-border-bottom pb-0"><strong>{t('layout:search.group.encounters')}</strong></ListGroup.Item>
                        {resultados.atendimentos.map(atendimento => (
                            <ListGroup.Item key={atendimento.id}>
                                <a href={`/atendimentos/edit/${atendimento.id}`} className="text-search">
                                    {`${atendimento.id} - ${atendimento.paciente}`}
                                </a>
                                <br />
                                <p className="mb-0 text-muted"><small>Médico: {atendimento.medico} | Laboratório: {atendimento.laboratorio}</small></p>
                            </ListGroup.Item>
                        ))}
                    </>
                )}
                {temPacientes && (
                    <>
                        <ListGroup.Item className="no-border-bottom pb-0"><strong>{t('layout:search.group.patients')}</strong></ListGroup.Item>
                        {resultados.pacientes.map(paciente => (
                            <ListGroup.Item key={paciente.id}>
                                <a href={`/pacientes/edit/${paciente.id}`} className="text-search">
                                    {`${paciente.id} - ${paciente.nome}`}
                                </a>
                                <br />
                                <p className="mb-0 text-muted"><small>{formataCPF(paciente.cpf)}</small></p>
                            </ListGroup.Item>
                        ))}
                    </>
                )}
                {temPrestadores && (
                    <>
                        <ListGroup.Item className="no-border-bottom pb-0"><strong>{t('layout:search.group.providers')}</strong></ListGroup.Item>
                        {resultados.prestadores.map(prestador => (
                            <ListGroup.Item key={prestador.id}>
                                <a href={`/prestadores/edit/${prestador.id}`} className="text-search">
                                    {`${prestador.id} - ${prestador.nome}`}
                                </a>
                                <br />
                                <p className="mb-0 text-muted"><small>{prestadoresCategorias[prestador.categoria]}</small></p>
                            </ListGroup.Item>
                        ))}
                    </>
                )}
            </>
        );
    }

    handleTermosAceitos = () => {
        // Salva no cache que os termos foram aceitos agora
        localStorage.setItem(TERMOS_CACHE_KEY, Date.now().toString());
        
        this.setState({ 
            showTermosModal: false, 
            termosPendentes: [] 
        });
    };

    handleTermosRecusados = () => {
        const { t } = this.props;

        Swal.fire({
            title: t('layout:terms.requiredTitle'),
            text: t('layout:terms.requiredText'),
            icon: "warning",
            confirmButtonText: t('layout:terms.requiredConfirm'),
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then(() => {
            logout();
            const programa_login = Cookies.get('p_login');
            Cookies.remove('p_login', { path: '/' });

            if (programa_login) {
                window.location.href = `/login/?p=${programa_login}`;
            } else {
                window.location.href = '/login';
            }
        });
    };

    render() {
        const { termoBusca, buscando, exibe_busca } = this.state;
        const dados_usuario = getCurrentUser();
        const { t } = this.props;

        if (this.state.loadingTermos) {
            return (
                <div style={{
                    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
                    backgroundColor: 'rgba(255, 255, 255, 0.9)', zIndex: 2000,
                    display: 'flex', justifyContent: 'center', alignItems: 'center'
                }}>
                    <Spinner animation="border" variant="primary" />
                </div>
            );
        }

        if (this.state.showTermosModal) {
            return (
                <TermosAcceptModal
                    show={true} // Sempre true se chegamos aqui
                    termos={this.state.termosPendentes}
                    userId={null} // Não é mais necessário
                    onAccept={this.handleTermosAceitos}
                    onDecline={this.handleTermosRecusados}
                    termosDinamicos={this.state.termosDinamicos}
                    termosDinamicosTitulo={this.state.termosDinamicosTitulo}
                    prestadorUuid={this.state.termosDinamicosPrestadorUuid}
                    programaUuid={this.state.termosDinamicosProgramaUuid}
                    respostasIniciais={this.state.termosDinamicosRespostas}
                    labelAceiteTermos={this.state.labelAceiteTermos}
                />
            );
        }
        
        return (
            <> 
                <Navbar variant="white">
                    <Container fluid>
                        <Button variant="white" id="sidebarToggle" onClick={this.sidebarToggle}>
                            <FiMenu /> 
                        </Button>
                            {
                            this.state.dadosPrograma.length > 0 && (
                                <div 
                                    className="d-flex align-items-center flex-grow-1 flex-lg-grow-0 me-auto ms-3" 
                                >
                                    <span className="me-2 d-none d-md-inline" style={{ fontSize: '15px', color: '#fff', fontWeight: 500, whiteSpace: 'nowrap' }}>
                                        {this.state.nomenclaturaPrograma ? t('layout:programSwitch.currentNamed', { nome: this.state.nomenclaturaPrograma }) : t('layout:programSwitch.current')}
                                    </span>
                                    <Select
                                        options={this.state.dadosPrograma.map(p => ({
                                            value: p.id,
                                            label: p.nome
                                        }))}
                                        onChange={(option) => {
                                            const programaSelecionado = this.state.dadosPrograma.find(p => p.id === option.value);
                                            if (programaSelecionado) {
                                                this.alterarAmbiente(programaSelecionado);
                                            }
                                        }}
                                        placeholder={this.state.nomenclaturaPrograma ? t('layout:programSwitch.selectPlaceholderNamed', { nome: this.state.nomenclaturaPrograma.toLowerCase() }) : t('layout:programSwitch.selectPlaceholder')}
                                        noOptionsMessage={() => t('layout:programSwitch.noOptions')}
                                        isClearable={false}
                                        value={(() => {
                                            const ambienteProgramaId = dados_usuario["ambiente_programa_id"];
                                            // Sem programa selecionado (ex.: médico recém-logado com vários programas):
                                            // retorna null para o Select exibir o placeholder, em vez de "Carregando...".
                                            if (!ambienteProgramaId) return null;
                                            const nomePrograma = localStorage.getItem(`programa_nome_${ambienteProgramaId}`)
                                                || this.state.dadosPrograma.find(p => p.id === ambienteProgramaId)?.nome;
                                            return { value: ambienteProgramaId, label: nomePrograma || 'Carregando...' };
                                        })()}
                                        styles={{
                                            container: (base) => ({
                                                ...base,
                                                minWidth: '220px'
                                            }),
                                            control: (base, state) => ({
                                                ...base,
                                                minHeight: '34px',
                                                borderColor: state.isFocused ? '#0d6efd' : 'transparent',
                                                backgroundColor: '#fff',
                                                boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(13, 110, 253, 0.15)' : '0 1px 2px rgba(0,0,0,0.05)',
                                                '&:hover': { 
                                                    borderColor: '#0d6efd',
                                                    boxShadow: '0 2px 4px rgba(0,0,0,0.08)'
                                                },
                                                fontSize: '13px',
                                                fontWeight: 500,
                                                borderRadius: '6px',
                                                transition: 'all 0.2s ease'
                                            }),
                                            valueContainer: (base) => ({ 
                                                ...base, 
                                                padding: '2px 8px'
                                            }),
                                            singleValue: (base) => ({
                                                ...base,
                                                color: '#212529',
                                                fontWeight: 500
                                            }),
                                            input: (base) => ({ 
                                                ...base, 
                                                margin: 0, 
                                                padding: 0 
                                            }),
                                            indicatorSeparator: () => ({ display: 'none' }),
                                            dropdownIndicator: (base) => ({ 
                                                ...base, 
                                                padding: '4px',
                                                color: '#6c757d',
                                                '&:hover': {
                                                    color: '#0d6efd'
                                                }
                                            }),
                                            menu: (base) => ({ 
                                                ...base, 
                                                fontSize: '13px',
                                                borderRadius: '6px',
                                                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                                border: '1px solid #e0e0e0',
                                                overflow: 'hidden'
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                backgroundColor: state.isSelected ? '#0d6efd' : state.isFocused ? '#f0f7ff' : '#fff',
                                                color: state.isSelected ? '#fff' : '#212529',
                                                fontWeight: state.isSelected ? 500 : 400,
                                                padding: '8px 12px',
                                                cursor: 'pointer',
                                                '&:active': {
                                                    backgroundColor: '#0d6efd'
                                                }
                                            })
                                        }}
                                    />
                                </div>
                                )
                            }
                        <Navbar.Collapse id="basic-navbar-nav">
                            <Nav className="ms-auto position-relative">
                                {(dados_usuario['operador_id'] > 0 || dados_usuario['tipo_usuario'] == '') && 1 != 1 && (
                                    <Form 
                                        className="d-flex position-relative search-form" 
                                        ref={this.searchContainer}
                                    >
                                        <Form.Control
                                            type="search"
                                            placeholder={t('layout:search.placeholder')}
                                            className="me-2 search-input"
                                            aria-label={t('layout:search.placeholder')}
                                            value={termoBusca}
                                            onChange={this.handleInputChange}
                                            onFocus={() => this.setState({ exibe_busca: termoBusca.trim().length > 0 })}
                                        />
                                        <InputGroup.Text 
                                            className="position-absolute end-0 me-2 search-icon"
                                            onClick={termoBusca ? this.clearSearch : null}
                                            style={{ cursor: termoBusca ? 'pointer' : 'default' }}
                                        >
                                            {buscando ? <FiLoader className="spin" /> : (termoBusca ? <FiX /> : <FiSearch />)}
                                        </InputGroup.Text>
                                        {exibe_busca && (
                                            <div className="resultados-busca">
                                                <div className="resultados-busca-inner">
                                                    <ListGroup>
                                                        {this.renderResultados()}
                                                    </ListGroup>
                                                </div>
                                            </div>
                                        )}
                                    </Form>
                                )}

                                {['operador', 'gestor', ''].includes(dados_usuario.tipo_usuario) && !this.isPerfilGestorIndustria() && !this.isPerfilGestorLeads() && (
                                    <NotificacaoBell />
                                )}
                                
                                <NavDropdown align="end" menuVariant="white" title={(this.state.currentUser.name) ? this.state.currentUser.name + ' ' + this.state.currentUser.last_name : this.state.currentUser.username} id="basic-nav-dropdown">
                                    {(dados_usuario['tipo_usuario'] === 'operador' || dados_usuario['tipo_usuario'] === 'gestor' || (dados_usuario['tipo_usuario'] === 'prestador' && dados_usuario['prestador_categoria'] !== 'medicos')) && this.state.currentUser.ambiente_cliente_id > 0 && (
                                        <NavDropdown.Item href="/" onClick={this.alterarAmbiente}>{t('menu:user.switchEnvironment')}</NavDropdown.Item>
                                    )}
                                    {this.state.currentUser.prestador_id && (
                                        <NavDropdown.Item href="/minha-conta">{t('menu:user.myAccount')}</NavDropdown.Item>
                                    )}
                                    <NavDropdown.Item href="/logout">{t('menu:user.logout')}</NavDropdown.Item>
                                    <SeletorIdiomaNav />
                                </NavDropdown>
                            </Nav>
                        </Navbar.Collapse>                        
                    </Container>
                </Navbar>
                
                <ModalTrocaPrograma 
                    show={this.state.showSwitchModal}
                    onHide={() => this.setState({ showSwitchModal: false })}
                    targetProgram={this.state.selectedProgram}
                    onSuccess={this.handleSwitchSuccess}
                />
            </>
        )
    }
}

TopNavigation.propTypes = {
    t: PropTypes.func.isRequired,
};

export default withTranslation(["menu", "layout", "common"])(TopNavigation);
